import { wsCall, requestHelper } from "../../../app/coreSlice";

const carclubDetailsCall = async ({ setCarclubDetails }, dispatch, state) => {
  const selectedLocation = state?.getIn(["carclub2"])?.defaultLocation;
  let rh = requestHelper(dispatch, "CARCLUB/DETAILS");
  let result;
  try {
    result = await wsCall({
      type: "CARCLUB",
      subType: "DETAILS",
      locationId: selectedLocation?.id,
    });

    if (!result.error) {
      dispatch(setCarclubDetails(result));
      // refresh reservations
    } else {
      rh.error(result?.description || "Error loading carclub details.");
    }
  } catch (_ex) {
    rh.error("Error loading carclub details.");
  }
  rh.close();
  return result;
};

export default carclubDetailsCall;
